import React, { useEffect, useState } from 'react';
import { Container, Circle } from './styles';

import { FiClock } from 'react-icons/fi';

export const CountDown = () => {
    
    const calculateTimeLeft = () => {
        let year = new Date().getFullYear();
        let difference = +new Date(`05/26/${year}`) - +new Date();
        
        let timeLeft = {};
        
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
                miliseconds:  Math.floor((difference / 1000))
            };
        }
        
        return timeLeft;
    }

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);
      
        return () => clearTimeout(timer);
      });
      
  
  
    return (
        <Container>
            <span style={{marginBottom: "2rem"}}> Semana nº: {60/7 - timeLeft.days/7 + 1} </span>
            <Circle perc="50%" style={{"width":"260px", "height":"260px", "border": "15px solid #FA124F"}}>
                {/* <Circle style={{"width":"260px", "height":"260px", "border": "15px solid #6ED940"}}> */}
                    <FiClock />
                    <h1 style={{"fontSize": "50px", "marginTop": "1rem", "color": "black"}}>{String(timeLeft.days).padStart(2, '0')}</h1>
                    <span>dias</span>
                    <div className="clock">{String(timeLeft.hours).padStart(2, '0')+":"+String(timeLeft.minutes).padStart(2, '0')+":"+String(timeLeft.seconds).padStart(2, '0')}</div>
                {/* </Circle> */}
            </Circle>
        </Container>
    );
};


